import { ItemHealthLevel } from '@/lib/api/types/dashboard/health';
import { SEVERITY, type Severity } from './severity';

export const HEALTH_LEVEL_SEVERITY: Record<ItemHealthLevel, Severity> = {
  [ItemHealthLevel.HEALTHY]: SEVERITY.SUCCESS,
  [ItemHealthLevel.NEEDS_ATTENTION]: SEVERITY.WARNING,
  [ItemHealthLevel.ACTION_REQUIRED]: SEVERITY.ERROR,
  [ItemHealthLevel.DONE]: SEVERITY.INFORMATIVE,
};
